import React from 'react';
import { motion } from 'framer-motion';


export default function Home() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Hero Section with Responsive Height */}
      <section className="relative min-h-[60vh] sm:min-h-[75vh] md:min-h-[90vh] flex flex-col justify-center items-center">
        <motion.div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('/images/peace.webp')" }}
          initial={{ scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2, ease: "easeOut" }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </motion.div>

        <motion.div
          className="relative z-10 px-3 xs:px-4 sm:px-8 text-white text-center w-full max-w-3xl"
          initial={{ opacity: 0, y: 80, rotateX: 25 }}
          animate={{ opacity: 1, y: 0, rotateX: 0 }}
          transition={{ duration: 1, type: "spring", stiffness: 70 }}
        >
          <motion.h1
            className="text-2xl xs:text-4xl sm:text-5xl md:text-6xl font-extrabold mb-4 sm:mb-6 leading-tight"
            initial={{ opacity: 0, y: 40, scale: 0.97, rotateY: -10 }}
            animate={{ opacity: 1, y: 0, scale: 1, rotateY: 0 }}
            transition={{ delay: 0.4, duration: 0.9, type: "spring" }}
          >
            FALCON LAW 
          </motion.h1>
          <motion.p
            className="text-base xs:text-lg md:text-2xl font-medium mb-6 sm:mb-8 leading-normal"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            Strength in Advocacy. Heart in Service.
          </motion.p>
          <motion.a
            href="/services"
            className="inline-block bg-white text-blue-900 px-6 xs:px-8 py-3 xs:py-4 text-base xs:text-lg md:text-xl font-bold rounded-lg hover:bg-gray-200 transition"
            whileHover={{
              scale: 1.07,
              rotateY: 7,
              boxShadow: "0 8px 32px 0 rgba(30,64,175,0.13)",
            }}
            transition={{ type: "spring", stiffness: 300 }}
          >
           Our Services
          </motion.a>
        </motion.div>
      </section>

      {/* About Falcon Law Firm Section */}
      <motion.section
        className="bg-white py-10 px-3 sm:px-6 lg:px-12"
        initial={{ opacity: 0, y: 100, rotateX: 15 }}
        whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, type: "spring", bounce: 0.2 }}
      >
        <div className="max-w-2xl mx-auto text-center">
          <motion.h2
            className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-blue-900 mb-4 sm:mb-7"
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.7 }}
          >
            About Falcon Law
          </motion.h2>
          <motion.p
            className="text-gray-700 text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3, duration: 0.7 }}
          >
            At Falcon Law, we are committed to delivering clear, compassionate, and results-driven legal solutions
            tailored to individuals, families, and businesses. With experience in both Indian and Canadian legal
            systems, our team understands the unique cultural and legal challenges our clients face, whether in
            family law, immigration, real estate, wills and estates, civil litigation, personal injury, employment, or
            commercial law.
            <br /><br />
            We take pride in blending legal expertise with empathy, integrity, and a client-first approach. We
            proudly offer services in multiple languages and strive to ensure our guidance is not only effective but
            also responsive and accessible.
            <br />
            Our clients can expect honest advice, strong advocacy, and thoughtful legal support at every step.
          </motion.p>
        </div>
      </motion.section>

     

      {/* Map Section */}
      <section className="w-full">
        <iframe
          title="Falcon Law Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2504.698035525074!2d-114.04792422329461!3d51.11403127172648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716505ec12a779%3A0x4e3a69309e005449!2sFalcon%20Law!5e0!3m2!1sen!2sin!4v1753976884402!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{ border: 0, minHeight: "300px", width: "100%", display: "block" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="block w-full"
        ></iframe>
      </section>
    </div>
  );
}
